import { GetRecordByIdResult } from '@indigohive/cogfy-types/endpoints/getRecordById'
import { GetCollectionFieldsResultData } from '@indigohive/cogfy-types/endpoints/getCollectionFields'
import type {
  FileRecordProperty,
  UUID
} from '@indigohive/cogfy-types'
import { FileRecordPropertyInputDefaultVariant } from './FileRecordPropertyInputDefaultVariant'
import { FileRecordPropertyInputMicVariant } from './FileRecordPropertyInputMicVariant'
import { Toggle } from '../../../../components'
import { MicIcon } from 'lucide-react'
import useLocalStorage from 'use-local-storage'

export type FileRecordPropertyInputProps = {
  collectionId: UUID
  field: Extract<GetCollectionFieldsResultData, { type: 'file' }>
  record: GetRecordByIdResult
  canEdit?: boolean
  disabled?: boolean
}

export function FileRecordPropertyInput (props: FileRecordPropertyInputProps) {
  const { record, field } = props
  const [micVariant, setMicVariant] = useLocalStorage(`${field.id}-mic-variant`, false)

  const isAudio = (record.properties[field.id] as FileRecordProperty).file?.value?.type?.includes('audio')
  const isEmpty = !(record.properties[field.id] as FileRecordProperty).file?.value
  const micVariantDisabled = !isAudio && !isEmpty

  return (
    <div className='flex justify-between'>
      {!micVariant &&
        <FileRecordPropertyInputDefaultVariant {...props} />
      }
      {micVariant &&
        <FileRecordPropertyInputMicVariant {...props} />
      }
      <Toggle
        label={<MicIcon size={20} opacity={micVariantDisabled ? 0.5 : 1} />}
        color='primary'
        disabled={micVariantDisabled}
        checked={micVariant}
        onChange={() => setMicVariant(current => !current)}
      />
    </div>
  )
}
